export default __webpack_public_path__ + "static/media/back_header.ccdb03a8.png";